export default "__VITE_ASSET__BIp7X$Ay__"